import React, { createContext, useContext, useState } from "react";

const FormCompletionContext = createContext();

export const useFormCompletion = () => useContext(FormCompletionContext);

export const FormCompletionProvider = ({ children }) => {
  const [completedForms, setCompletedForms] = useState({
    customer_details: true,
    delivery_details: false,
    confirm_details: false,
  });

  const [formData, setFormData] = useState({
    customer_details: {},
    delivery_details: {},
    confirm_details: {},
  });

  const markFormAsCompleted = (formName) => {
    setCompletedForms((prev) => ({ ...prev, [formName]: true }));
  };

  const saveFormData = (formName, data) => {
    setFormData((prev) => ({ ...prev, [formName]: data }));
  };

  return (
    <FormCompletionContext.Provider
      value={{ completedForms, markFormAsCompleted, formData, saveFormData }}
    >
      {children}
    </FormCompletionContext.Provider>
  );
};
